import { useCompanyId } from '@startuptools/common/react-wrapper';
import { NumberFormat } from '@startuptools/ui/NumberFormat';
import { Trans, useLingui } from '@lingui/react';
import { Typography } from '@startuptools/ui/joy/Typography';
import { Stack } from '@startuptools/ui/joy/Stack';
import { Card } from '@startuptools/ui/joy/Card';
import React from 'react';
import { GqlSortOrder } from '../../../graphql/base-types.graphql';
import { InfoCard } from '@startuptools/business-ui/InfoCard';
import { OptionsList, OptionsListSuspense } from './components/OptionsList';
import { useOptionOverviewQuery } from './option-overview.graphql';

export const Overview = () => {
  const { i18n } = useLingui();

  const companyId = useCompanyId();

  const { data } = useOptionOverviewQuery({
    variables: {
      companyId,
      limit: 0,
      offset: 0,
      sort: { field: 'identity.name', direction: GqlSortOrder.Desc },
    },
  });

  return (
    <Card sx={{ overflow: 'auto' }}>
      <Stack gap={2}>
        <Typography level="h2">
          <Trans id="Options" />
        </Typography>

        <Stack direction="column" gap={2}>
          <Stack direction="row" gap={2} alignItems="center">
            <InfoCard
              sx={{ maxWidth: 200 }}
              label={<Trans id="Issued Options" />}
              value={
                data?.companyStatistics.issuedOptions ? (
                  <NumberFormat locale={i18n.locale} maximumFractionDigits={0}>
                    {data?.companyStatistics.issuedOptions ?? '...'}
                  </NumberFormat>
                ) : (
                  '...'
                )
              }
            />
          </Stack>

          <React.Suspense
            fallback={
              <OptionsList
                showSplitAdjusted={false}
                setShowSplitAdjusted={() => {
                  /* noop */
                }}
                companyId={companyId}
                page={0}
                setPage={() => {
                  /* noop */
                }}
                rowsPerPage={25}
                setRowsPerPage={() => {
                  /* noop */
                }}
                sort={{ field: 'identity.name', direction: GqlSortOrder.Desc }}
                setSort={() => {
                  /* noop */
                }}
              />
            }
          >
            <OptionsListSuspense />
          </React.Suspense>
        </Stack>
      </Stack>
    </Card>
  );
};
